import React from 'react';
import { Box } from '@common-fe/common-fe';

import { AllowedPaymentMethodConfig } from '@/modules/employer/types';

import CustomReports from './CustomReports';
import EmployerInfo from './EmployerInfo';
import EmploymentStatusTimeline from './EmploymentStatusTimeline';
import GeneralInfo from './GeneralInfo';
import HealthPlanClaims from './HealthPlanClaims';
import PaymentMethodInfo from './PaymentMethodInfo';
import PreferredMailingAddress from './PreferredMailingAddress';
import PreferredPhysicalAddress from './PreferredPhysicalAddress';

interface Props {
  isEditMode?: boolean;
  isShowErrors?: boolean;
  notes?: string;
  isOrganizationLocked?: boolean;
  children?: React.ReactNode;
  allowedPaymentMethodConfigs?: AllowedPaymentMethodConfig[];
}
const PersonalInformation: React.FC<Props> = React.memo(({
  isEditMode,
  children,
  isShowErrors,
  notes,
  isOrganizationLocked,
  allowedPaymentMethodConfigs,
}) => (
  <Box direction="column" background="module" pad="spacing24" round="moduleRound">
    {children}
    <GeneralInfo isShowErrors={isShowErrors} isEditMode={isEditMode} />

    <Box>
      <CustomReports isShowErrors={isShowErrors} isEditMode={isEditMode} /> 
    </Box>
    <Box margin={{ top: 'spacing24' }}>
      <PreferredMailingAddress isShowErrors={isShowErrors} isEditMode={isEditMode} />
    </Box>
    <Box margin={{ top: 'spacing24' }}>
      <PreferredPhysicalAddress isShowErrors={isShowErrors} isEditMode={isEditMode} />
    </Box>
    <Box margin={{ top: 'spacing24' }}>
      <PaymentMethodInfo allowedPaymentMethodConfigs={allowedPaymentMethodConfigs} />
    </Box>
    <Box margin={{ top: 'spacing24' }}>
      <EmployerInfo
        isShowErrors={isShowErrors}
        isEditMode={isEditMode}
        notes={notes}
        isOrganizationLocked={isOrganizationLocked}
      />
    </Box>
    <EmploymentStatusTimeline />
    <Box margin={{ top: 'spacing24' }}>
      <HealthPlanClaims isEditMode={isEditMode} />
    </Box>
  </Box>
));

export default PersonalInformation;
